import { Component, Input } from "@angular/core";

@Component({
  selector: "app-job-header",
  templateUrl: "./job-header.component.html",
  styleUrls: ["./job-header.component.scss"],
})
export class JobHeaderComponent {
  @Input()
  job: JobHeaderInfo = {
    companyLogoUrl: "",
    company: "",
    title: "",
    city: "",
    wage: 0,
  };

  getJobWageComponents(wage: number) {
    return wage.toFixed(2).split(".");
  }
}

export interface JobHeaderInfo {
  companyLogoUrl: string;
  title: string;
  company: string;
  city: string;
  wage: number;
}
